export const SET_SETUP = "SET_SETUP";
export const SET_SETUP_KEY = "SET_SETUP_KEY";
export const CLEAR_STATE = "CLEAR_STATE";
export const SET_INITIAL_SETUP_DONE = "SET_INITIAL_SETUP_DONE";
export const SET_SHOW_TRENDS = "SET_SHOW_TRENDS";
export const SET_SETUP_CONFIG = "SET_SETUP_CONFIG";
export const SET_SHOW_PUBLICATIONS_FILTER = "SET_SHOW_PUBLICATIONS_FILTER";
export const GET_DASHBOARD_LIST = "GET_DASHBOARD_LIST";
export const GET_DASHBOARD_LIST_SUCCESS = "GET_DASHBOARD_LIST_SUCCESS";
export const GET_DASHBOARD_LIST_FAIL = "GET_DASHBOARD_LIST_FAIL";
export const SET_SELECTED_DASHBOARD = "SET_SELECTED_DASHBOARD";
export const GET_SETUP_CONFIG = "GET_SETUP_CONFIG";
export const GET_SETUP_CONFIG_SUCCESS = "GET_SETUP_CONFIG_SUCCESS";
export const GET_SETUP_CONFIG_FAIL = "GET_SETUP_CONFIG_FAIL";
export const SET_ID_DATES = "SET_ID_DATES";
export const SET_ID_PRINTING = "SET_ID_PRINTING";
